<template>
<a @click.prevent="choosePin" href="#" class="trade-link" data-bs-toggle="modal" data-bs-target="#trade-pin-detail"><slot></slot></a>
</template>

<script>
export default {
    name: 'TradeLink',
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    methods: {
        choosePin() {
            VueEvent.$emit('chosenTradePin', this.id);
        }
    },
}
</script>
